import useProject from './useProject';

const useUserCanEditProject = () => {
  const { data: project } = useProject();

  return Boolean(project.canEdit);
};

export default useUserCanEditProject;
